var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebDev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 178.96 126.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#7da2fe;}.cls-3{fill:rgba(255,255,255,.2);}.cls-3,.cls-4,.cls-5{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}.cls-4{fill:none;stroke-width:5px;}.cls-5{fill:#1e83f7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M178.46,5.48v13.99H.5V5.48C.5,2.73,2.74,.5,5.48,.5H173.48c2.75,0,4.98,2.23,4.98,4.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M178.46,19.47V120.58c0,2.75-2.23,4.98-4.98,4.98H5.48c-2.75,0-4.98-2.23-4.98-4.98V19.47H178.46Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "76.05 82.87 65.7 72.52 76.05 62.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "102.91 62.16 113.26 72.52 102.91 82.87"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 84.32,
    y1: 83.83,
    x2: 94.77,
    y2: 61.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 13.67,
    cy: 9.99,
    r: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.67,7.49c1.38,0,2.5,1.12,2.5,2.5s-1.12,2.5-2.5,2.5-2.5-1.12-2.5-2.5,1.12-2.5,2.5-2.5m0-2c-2.48,0-4.5,2.02-4.5,4.5s2.02,4.5,4.5,4.5,4.5-2.02,4.5-4.5-2.02-4.5-4.5-4.5h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 26.67,
    cy: 9.99,
    r: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.67,7.49c1.38,0,2.5,1.12,2.5,2.5s-1.12,2.5-2.5,2.5-2.5-1.12-2.5-2.5,1.12-2.5,2.5-2.5m0-2c-2.48,0-4.5,2.02-4.5,4.5s2.02,4.5,4.5,4.5,4.5-2.02,4.5-4.5-2.02-4.5-4.5-4.5h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 39.67,
    cy: 9.99,
    r: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.67,7.49c1.38,0,2.5,1.12,2.5,2.5s-1.12,2.5-2.5,2.5-2.5-1.12-2.5-2.5,1.12-2.5,2.5-2.5m0-2c-2.48,0-4.5,2.02-4.5,4.5s2.02,4.5,4.5,4.5,4.5-2.02,4.5-4.5-2.02-4.5-4.5-4.5h0Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDev);
export default __webpack_public_path__ + "static/media/web-dev.ef43fc04f4175aa9f40c1bf05bb5e202.svg";
export { ForwardRef as ReactComponent };